import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib"; // 重复数据后台判断

import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import ClientListTable from '@/components/ClientListTable.vue';
import ClientInfoFormDialog from './ClientInfoFormDialog.vue';

var ClientInfo = /*#__PURE__*/function (_Vue) {
  _inherits(ClientInfo, _Vue);

  var _super = _createSuper(ClientInfo);

  function ClientInfo() {
    var _this;

    _classCallCheck(this, ClientInfo);

    _this = _super.apply(this, arguments);
    _this.dialogFormVisible = false; // 编辑时使用

    _this.tempClient = null;
    _this.tempClientIndex = 0;
    return _this;
  }

  _createClass(ClientInfo, [{
    key: "handleDialogSubmit",
    value: function handleDialogSubmit(e) {
      if (this.tempClient === null) {
        // 新建
        this.clientList.push(e);
      } else {
        // 编辑
        // 因在 ProxyInfo 中可能引用了 clientList 的每一项，需要保持为同一引用对象
        for (var key in e) {
          if (Object.prototype.hasOwnProperty.call(e, key)) {
            this.clientList[this.tempClientIndex][key] = e[key];
          }
        }
      }
    }
  }, {
    key: "handleEdit",
    value: function handleEdit(item) {
      var index = item.$index,
          data = item.row; // this.tempClient = Object.assign({}, data)

      this.tempClient = data;
      this.tempClientIndex = index;
      this.dialogFormVisible = true;
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(item) {
      return item;
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.tempClient = null;
      this.dialogFormVisible = true;
    }
  }]);

  return ClientInfo;
}(Vue);

__decorate([Prop({
  required: true,
  type: Array
})], ClientInfo.prototype, "litigationStatusIdOptions", void 0);

__decorate([Prop({
  required: true
})], ClientInfo.prototype, "clientList", void 0);

__decorate([Emit('onDelete')], ClientInfo.prototype, "handleDelete", null);

ClientInfo = __decorate([Component({
  components: {
    ClientInfoFormDialog: ClientInfoFormDialog,
    ClientListTable: ClientListTable
  }
})], ClientInfo);
export default ClientInfo;